import { render, staticRenderFns } from "./BatchTag.vue?vue&type=template&id=02ca8d22"
import script from "./BatchTag.vue?vue&type=script&lang=js"
export * from "./BatchTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports